var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3516 5V2.64844H9.64844V5H14.3516ZM21.3516 5C22.0078 5 22.5547 5.23698 22.9922 5.71094C23.4297 6.14844 23.6484 6.69531 23.6484 7.35156V20.1484C23.6484 20.8047 23.4297 21.3698 22.9922 21.8438C22.5547 22.2812 22.0078 22.5 21.3516 22.5H2.64844C1.99219 22.5 1.44531 22.2812 1.00781 21.8438C0.570312 21.3698 0.351562 20.8047 0.351562 20.1484V7.35156C0.351562 6.69531 0.570312 6.14844 1.00781 5.71094C1.44531 5.23698 1.99219 5 2.64844 5H7.35156V2.64844C7.35156 1.99219 7.57031 1.44531 8.00781 1.00781C8.44531 0.570312 8.99219 0.351562 9.64844 0.351562H14.3516C15.0078 0.351562 15.5547 0.570312 15.9922 1.00781C16.4297 1.44531 16.6484 1.99219 16.6484 2.64844V5H21.3516Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleIcon);
export default __webpack_public_path__ + "static/media/RoleIcon.e0e16cac45bf3c0f125baff950d24fa5.svg";
export { ForwardRef as ReactComponent };